module.exports = __webpack_public_path__ + "img/steps1.46e0bcdc.png";